import classNames from 'classnames';
import { Skeleton } from 'components/layout/loading';
import { SKELETON_VARIANTS } from 'components/layout/loading/Skeleton/constants';

function WidgetShell({ title, actions, loading, error, onRetry, empty, emptyMessage, children, className }) {
  return (
    <div className={classNames('rounded-2xl border border-white/10 bg-gray-900 p-5 shadow-sm', className)}>
      {(title || actions) && (
        <div className="mb-4 flex items-center justify-between">
          {title && <h3 className="text-sm font-medium text-gray-400">{title}</h3>}
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
      )}

      {loading && (
        <div className="space-y-3">
          <Skeleton variant={SKELETON_VARIANTS.RECTANGULAR} className="h-8 w-24" />
          <Skeleton variant={SKELETON_VARIANTS.RECTANGULAR} className="h-4 w-full" />
          <Skeleton variant={SKELETON_VARIANTS.RECTANGULAR} className="h-4 w-3/4" />
        </div>
      )}

      {!loading && error && (
        <div className="text-center py-4">
          <p className="text-sm text-red-400 mb-2">{typeof error === 'string' ? error : 'Something went wrong'}</p>
          {onRetry && (
            <button
              type="button"
              onClick={onRetry}
              className="text-sm font-medium text-indigo-400 hover:text-indigo-300 transition-colors"
            >
              Retry
            </button>
          )}
        </div>
      )}

      {!loading && !error && empty && (
        <p className="text-center text-sm text-gray-500 py-4">
          {emptyMessage || 'No data available'}
        </p>
      )}

      {!loading && !error && !empty && children}
    </div>
  );
}

export default WidgetShell;
